// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-left"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M9 12.25H4.5C3.39543 12.25 2.5 11.3546 2.5 10.25C2.5 9.14543 3.39543 8.25 4.5 8.25H14.5L13.6486 4.41889C13.5591 4.01575 13.7265 3.599 14.0701 3.36991L15 2.75L20.7194 7.14955C21.2116 7.52815 21.5 8.11386 21.5 8.7348V16.8085C21.5 17.6693 20.9491 18.4336 20.1325 18.7058L14.0414 20.7362C13.1433 21.0356 12.1583 20.6643 11.6813 19.8466L9.27244 15.717C9.09402 15.4112 9 15.0634 9 14.7093V12.25Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 12.25H4.5C3.39543 12.25 2.5 11.3546 2.5 10.25C2.5 9.14543 3.39543 8.25 4.5 8.25H14.5L13.6486 4.41889C13.5591 4.01575 13.7265 3.599 14.0701 3.36991L15 2.75L20.7194 7.14955C21.2116 7.52815 21.5 8.11386 21.5 8.7348V16.8085C21.5 17.6693 20.9491 18.4336 20.1325 18.7058L14.0414 20.7362C13.1433 21.0356 12.1583 20.6643 11.6813 19.8466L9.27244 15.717C9.09402 15.4112 9 15.0634 9 14.7093V12.25Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureLeftIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gesture-left',
    ref,
    icon: element,
  },
));

GestureLeftIcon.displayName = 'GestureLeftIcon';

export default GestureLeftIcon;
